import React from 'react';

import { mergeStyleSets, mergeStyles, FontSizes, FontWeights } from '@fluentui/react';
import { Checkbox } from '@fluentui/react';

import SearchableComboBox from 'src/components/base/SearchableComboBox';


const textStyle = {
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
};

const classNames = mergeStyleSets({
  field: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: '8px',
    cursor: 'pointer',
    border: '1px solid transparent',

    selectors: {
      ':hover': {
        backgroundColor: '#f3f2f1'
      },
      '.read-only': mergeStyles(textStyle, {
        flex: 'none',
        fontSize: FontSizes.xSmall,
        fontWeight: FontWeights.semibold,
        border: '1px solid #A6A6A6',
        borderRadius: '2px',
        textAlign: 'center',
        padding: '4px',
        marginLeft: '8px',
        opacity: 1,
      }),
    },
  },

  titlesContainer: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1 1 auto',
    selectors: {
      '& > .text' : mergeStyles(textStyle, {
        fontSize: FontSizes.medium,
        fontWeight: FontWeights.regular,
        color: '#333',
      }),
      '& > .type' : mergeStyles(textStyle, {
        fontSize: FontSizes.small,
        color: '#666',
      })
    },
  },

  selectedField: {
    borderColor: 'black',
  },

  setting: {
    display: 'flex',
    flexFlow: 'row',
    alignItems: 'center',
  },

  settingText: {
    padding: '0 12px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',

    selectors: {
      '& > :first-child': {
        fontWeight: FontWeights.bold,
        fontSize: FontSizes.medium,
      },
      '& > :last-child': {
        display: 'inline-block',
        fontSize: FontSizes.small,
        // width: '100%',
        whiteSpace: 'break-spaces',
      },
    },
  },

});

const SF_ID_FIELD_NAME = 'Id';
const ERROR_COLOR = '#a4262c';


export function FieldSelector(props) {

  const { options, disabled, placeholder, selectedKey, onChange, errorMessage = '', invalid = false } = props;

  return (
    <SearchableComboBox
      placeholder={placeholder}
      selectedKey={selectedKey}
      onChange={(_, item) => onChange(item)}
      options={options}
      errorMessage={errorMessage}
      disabled={disabled}
      invalid={invalid}
      onRenderCell={(item, isSelected, onClick) => {
        return (
          <div
            className={`${classNames.field} ${isSelected && classNames.selectedField}`}
            onClick={(event) => onClick(event, item)}
            data-is-focusable="true">
            <div className={classNames.titlesContainer}>
              <span className="text">{item.text}</span>
              { item.type && <span className="type">{item.type}</span> }
            </div>
            { item.readOnly && <span className="read-only">READ-ONLY</span> }
          </div>
        );
      }}
    />
  );
}


export function CheckboxSetting({ title, text, selected, disabled, onChange }) {
  return (
    <div className={classNames.setting}>
      <Checkbox checked={selected} disabled={disabled} onChange={onChange} />
      <div className={classNames.settingText}>
        <span>{title}</span>
        <span>{text}</span>
      </div>
    </div>
  );
}
